import { ky } from './ky';
import { ExistResponse } from './common';

export default class PlaceLikeService {

  /**
   * 장소 좋아요 추가
   *
   * @param placeId 장소 ID
   */
  async like(placeId: number) {
    await ky.post(`v1/places/${placeId}/likes`);
  }

  /**
   * 장소 좋아요 취소
   *
   * @param placeId 장소 ID
   */
  async unlike(placeId: number) {
    await ky.delete(`v1/places/${placeId}/likes`);
  }

  /**
   * 장소 좋아요 여부 가져오기
   *
   * @param placeId 장소 ID
   */
  async exists(placeId: number) {
    return await ky.get(`v1/places/${placeId}/likes`).json() as ExistResponse;
  }

}